module.exports = __webpack_public_path__ + "img/portrait.4567fc4c.png";